export class PublicCartRecursive {
  public constructor(
    private readonly data: {
      price: number;
      firstRenewalDate: Date;
    },
  ) {}

  public get price(): number {
    return this.data.price;
  }

  public get firstRenewalDate(): Date {
    return this.data.firstRenewalDate;
  }
}
